import api from '../lib/axios';

export const getTickets = (params) => api.get('/tickets', { params });
export const getTicket = (id) => api.get(`/tickets/${id}`);
export const getTicketWorkflows = () => api.get('/tickets/workflows');
export const createTicket = (data) => api.post('/tickets', data);
export const updateTicket = (id, data) => api.patch(`/tickets/${id}`, data);
export const addTicketRemark = (id, data) => api.post(`/tickets/${id}/remarks`, data);
export const promoteTicket = (id, moduleId) => api.post(`/tickets/${id}/promote`, { moduleId });
export const deleteTicket = (id) => api.delete(`/tickets/${id}`);
